import type React from 'react';

import { CtaSection } from './components/CtaSection';
import { FilterableLocations } from './components/FilterableLocations';
import { MostVisitedLocationSection } from './components/MostVisitedLocationSection';

export const PageBody: React.FC = () => {
	return (
		<>
			<FilterableLocations />
			<MostVisitedLocationSection />
			<CtaSection />
		</>
	);
};
